import React from 'react'
import NewHeader from '../../../Layout/NewHeader'
import NewBanner2 from './NewBanner2'
import StatsLuxury from './StatsLuxury'


function NewHome2() {
  return (
    <div>
        <NewHeader/>
        <NewBanner2/>
        <StatsLuxury/>
    </div>
  )
}

export default NewHome2